import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../diccionarios/comisionesModulo';

@Injectable({
  providedIn: 'root'
})
export class CalendarioService {

  diccionarioUrl: any;
  urlMaestros: string;
  urlComisiones: string;
  constructor(
    private commom: CommonService,
    private utilServices: UtilsService
  ) {
    this.urlMaestros = this.utilServices.getDatosMaestros();
    this.urlComisiones = this.utilServices.getComisiones();
    this.diccionarioUrl = comisionesModulo.url.calendario;
  }

  getCalendarios() {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerTodo);
  }

  saveCalendario(innObj: any) {
    console.log("saveCalendario", innObj)
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.crear, innObj);
  }

  updateCalendario(innObj: any) {
    console.log("updateCalendario", innObj)
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.actualizar, innObj);
  }

  deleteCalendario(innObj: any) {
    return this.commom.peticionDeleteConHeader(this.urlComisiones + this.diccionarioUrl.eliminar, innObj);
  }

  savePeriodo(innObj: any) {
    console.log("savePeriodo", innObj)
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.crearPeriodo, innObj);
  }

  getPeriodo(innIdDireccion: any) {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerPeriodo + `${innIdDireccion}`);
  }

  deletePeriodo(innObj: any) {
    return this.commom.peticionDeleteConHeader(this.urlComisiones + this.diccionarioUrl.eliminarPeriodo, innObj);
  }

  duplicarCalendario(innObj: any) {
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.duplicar, innObj);
  }
  
}
